// forecasting data well types
export const CLOSED_WON = 'closedWon';
export const GAP = 'gap';
export const FORECAST_SUBMISSION = 'forecastSubmission';